import React from 'react';
import Icon from '../../../components/AppIcon';

const CoverLetterTab = ({ coverLetter }) => {
  if (!coverLetter) {
    return (
      <div className="text-center py-12">
        <Icon name="FileText" size={48} className="text-muted-foreground mx-auto mb-4" />
        <h3 className="text-lg font-medium text-foreground mb-2">No Cover Letter</h3>
        <p className="text-muted-foreground">This candidate did not submit a cover letter.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Cover Letter Header */}
      <div className="flex items-center justify-between p-4 bg-muted/50 rounded-lg">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
            <Icon name="FileText" size={20} className="text-blue-600" />
          </div>
          <div>
            <h3 className="font-medium text-foreground">Cover Letter</h3>
            <p className="text-sm text-muted-foreground">
              Submitted {coverLetter?.submittedDate}
            </p>
          </div>
        </div>
      </div>
      {/* Cover Letter Content */}
      <div className="border border-border rounded-lg overflow-hidden">
        <div className="bg-white p-8 space-y-6">
          {/* Letter Header */}
          <div className="text-right text-sm text-gray-600 mb-8">
            {coverLetter?.date}
          </div>

          {/* Recipient */}
          <div className="mb-8">
            <p className="text-gray-900">{coverLetter?.recipient}</p>
            <p className="text-gray-600">{coverLetter?.company}</p>
          </div>

          {/* Subject */}
          <div className="mb-6">
            <p className="font-medium text-gray-900">
              Re: {coverLetter?.subject}
            </p>
          </div>

          {/* Letter Content */}
          <div className="space-y-4 text-gray-700 leading-relaxed">
            {coverLetter?.content?.split('\n\n')?.map((paragraph, index) => (
              <p key={index} className="text-sm">
                {paragraph}
              </p>
            ))}
          </div>

          {/* Closing */}
          <div className="mt-8 space-y-2">
            <p className="text-gray-700">{coverLetter?.closing}</p>
            <p className="font-medium text-gray-900">{coverLetter?.candidateName}</p>
          </div>
        </div>
      </div>
      {/* Letter Statistics */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-muted/50 rounded-lg p-4 text-center">
          <div className="text-2xl font-semibold text-foreground">{coverLetter?.wordCount}</div>
          <div className="text-sm text-muted-foreground">Words</div>
        </div>
        <div className="bg-muted/50 rounded-lg p-4 text-center">
          <div className="text-2xl font-semibold text-foreground">{coverLetter?.readingTime}</div>
          <div className="text-sm text-muted-foreground">Min Read</div>
        </div>
        <div className="bg-muted/50 rounded-lg p-4 text-center">
          <div className="text-2xl font-semibold text-foreground">{coverLetter?.sentiment}</div>
          <div className="text-sm text-muted-foreground">Tone</div>
        </div>
      </div>
    </div>
  );
};

export default CoverLetterTab;